import {
  formatPurchasePlanningCurrency,
  formatPurchasePlanningCashRequired,
  formatPurchasePlanningNumber,
} from '../../../lib/purchasePlanningHelpers';

export function InventoryCapitalPlanSummaryBar({ summary }) {
  if (!summary) return null;

  const cards = [
    { label: 'SKUs in plan', value: formatPurchasePlanningNumber(summary.skuCount) },
    { label: 'Total cash required', value: formatPurchasePlanningCashRequired(summary.totalCashRequired) },
    { label: 'Rounded units', value: formatPurchasePlanningNumber(summary.totalAdjustedRoundedUnits) },
    { label: 'Avg unit cost', value: formatPurchasePlanningCurrency(summary.averageUnitCost) },
    { label: 'Missing unit cost', value: formatPurchasePlanningNumber(summary.missingCostCount) },
    { label: 'Unscheduled PO date', value: formatPurchasePlanningNumber(summary.unscheduledCount) },
  ];

  return (
    <div className="mt-4 grid gap-2 md:grid-cols-2 xl:grid-cols-6">
      {cards.map(card => (
        <div key={card.label} className="rounded-md border border-gray-200 bg-white px-3 py-2">
          <p className="text-[11px] uppercase tracking-[0.12em] text-gray-500">{card.label}</p>
          <p className="mt-1 text-lg font-semibold text-gray-900">{card.value}</p>
        </div>
      ))}
    </div>
  );
}
